export default __webpack_public_path__ + "static/media/EDENbazar-facebook.c0d190bb.png";